import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface IStore {
  currentLocation: string;
  setCurrentLocation: (location: string) => void;
}

export const useCurrentLocation = create<IStore>()(
  persist(
    (set) => ({
      currentLocation: "all",
      setCurrentLocation: (currentLocation) => {
        set({ currentLocation });
        window.location.reload();
      },
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
